import { Logger, type ResponseSuccess, type UserId } from '@terros/common'
import { useCallback, useContext } from 'react'
import { useBackend } from './BackendContext'
import { HeadersContext } from './HeadersContext'
import { serverRequest } from './api'

type Result<I, O extends ResponseSuccess> = (input: I) => Promise<O>

const logger = new Logger('apiHook')
// logger.level = 'verbose'

export const useServerRequest = <I, O extends ResponseSuccess>(
  path: string,
  impersonateOverride?: UserId
): Result<I, O> => {
  const backend = useBackend(impersonateOverride)
  const additionalHeaders = useContext(HeadersContext)

  return useCallback(
    (input: I): Promise<O> => {
      if (additionalHeaders) logger.verbose(`Sending ${Object.keys(additionalHeaders).length} additional headers`)
      return serverRequest<I, O>({
        backend,
        path,
        additionalHeaders,
        input,
      })
    },
    [backend, path, additionalHeaders]
  )
}
